/* The settings the app keeps for itself, and how they are spelled.
 *
 * Named constants rather than string literals at each end, because both ends
 * are far apart: the screen writes them into a SharePoint list and an Azure
 * Function reads them back four hours later. A typo would not fail, it would
 * quietly do nothing — which is how a digest ends up going to nobody with
 * everything apparently configured.
 *
 * sync/src/digest.ts carries the same key, and tests/digest.test.mjs checks the
 * two still match.
 */

/** Who the weekly digest goes to. One address per line. */
export const DIGEST_RECIPIENTS = 'digest.recipients';

/** Splits a stored multi-line list into addresses.
 *
 *  Newlines, commas and semicolons all count, because people paste all three
 *  and none of them is wrong. */
export function addressList(stored: string | undefined): string[] {
  return (stored ?? '')
    .split(/[\n,;]+/)
    .map((x) => x.trim())
    .filter(Boolean);
}

/** Roughly an address. Not RFC 5322 — that is a famously bad idea — just enough
 *  to catch the typo that stops a digest arriving. */
export function looksLikeAddress(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
